import { isAuthenticated } from '@/event/account/auth/authentification'
import { excludeRouteLoginArray } from '@/storage/navbar/excludeRoute'

export const goOutLogin = (routeName: any) => {
  return excludeRouteLoginArray.includes(routeName) && isAuthenticated.value
}
